import { ActivatedRouteSnapshot, Routes } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, matchAppVersionProductLoadGuard } from '../guards';

export default [
    {
        path: 'games',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
        canMatch: [
            allowedProductGuard,
            (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.GAMES, route),
        ],
        data: { product: ClientConfigProductName.CASINO },
    },
    {
        path: 'casino',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
        canMatch: [
            allowedProductGuard,
            (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.CASINO, route),
        ],
        data: { product: ClientConfigProductName.CASINO },
    },
    {
        // For .de labels
        path: 'slots',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
        canMatch: [
            (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.SLOTS, route),
        ],
        data: { product: ClientConfigProductName.CASINO },
    },
    {
        // For Gala-Simplification added new Route
        path: 'spins',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
        canMatch: [
            (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.SPINS, route),
        ],
        data: { product: ClientConfigProductName.CASINO },
    },
    {
        path: 'dice',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../casino/app/src/casino.routes').then((t) => t.CasinoRoutesModule),
        canMatch: [
            (route: ActivatedRouteSnapshot) => matchAppVersionProductLoadGuard(ClientConfigProductName.CASINO, SamePathAppVersion.DICE, route),
        ],
        data: { product: ClientConfigProductName.CASINO },
    },
] satisfies Routes;
